{
  "nl": {
    "partners": {
      "headings": {
        "course": "Nu verder leren met {partner}",
        "description": "Daarom bevelen wij {partner} aan:",
        "emptyState": "Helaas zijn er geen partnervermeldingen gevonden.",
        "feedback": "Mis je je favoriete tool of wil je een toepassing aanbevelen?",
        "materials": "Ontdek materialen van {partner}",
        "subtitle": "Wat wil je vandaag gebruiken?",
        "title": "Leer geselecteerde onderwijspartners kennen"
      },
      "hints": {
        "notPublished": "Deze partner is nog niet gepubliceerd. Alleen zichtbaar voor beheerders. 😎"
      },
      "links": {
        "breadCrumbIndex": "Partneroverzicht",
        "login": "Inloggen",
        "loginWithFobizz": "Nu inloggen met fobizz",
        "registerWithFobizz": "Nu uitproberen met fobizz",
        "sendFeedback": "Stuur ons gerust een e-mail naar"
      }
    }
  }
}
